export enum BuiltInPermissionGroup {
  STANDARD = 'Standard',
  ADMIN = 'Admin',
  ACCOUNT_ADMIN = 'Account Admin',
}
